module.exports = __webpack_public_path__ + "static/img/COOPER-SIMPSON.9dac61b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/COOPER-SIMPSON.jpg
// module id = G+00
// module chunks = 0